import { render } from "./ItemModal.vue?vue&type=template&id=20d43a8c&scoped=true"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"

import "./ItemModal.vue?vue&type=style&index=0&id=20d43a8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d43a8c"]])

export default __exports__